/* eslint-disable prettier */
/**
 * Created by calhosh on 4/14/2017.
 * HE ISR resource file
 */
export const labels = {
	title: 'EY Canvas Economics',
	status: 'סטטוס',
	header: 'כותרת',
	canvas: 'Canvas',
	canvasEconomics: 'כלכלת Canvas',
	badRequest: 'בקשה שגויה',
	errorBanner: '{ 0} שגיאה/ות',
	userProfileDropdown: {
		myProfile: 'הפרופיל שלי',
		signOut: 'התנתקות'
	},
	clientCode: 'קוד לקוח',
	hours: 'שעות',
	local: 'מקומי',
	currency: 'מטבעות',
	rate: 'שיעור',
	forecast: 'תחזית',
	variance: 'שונות',
	edit: 'ערוך',
	arrowUp: 'חץ למעלה',
	budget: 'תקציב',
	priorBudget: 'תקציב קודם',
	currentBudget: 'תקציב נוכחי',
	summary: 'סיכום',
	actual: 'בפועל',
	priorActual: 'בפועל - תקופה קודמת',
	currentActual: 'בפועל - תקופה נוכחית',
	remaining: 'נותר',
	adjustment: 'התאמה',
	estimate: 'אומדן',
	isRequired: 'נדרש {0}',
	isPositiveInteger: '{0} נדרש ועליו להיות מספר שלם שאינו שלילי.',
	isPositiveDecimal: '{0} נדרש ועליו להיות מספר חיובי עם 2 ספרות עשרוניות.',
	in: 'ב',
	id: 'ID',
	currentYear: 'שנה נוכחית',
	priorYear: 'שנה קודמת',
	budgetHierarchy: 'היררכיית תקציב',
	executionBudgetHierarchy: 'היררכיית תקציב ביצוע',
	noContentAvailable: 'אין תוכן זמין',
	viewMore: 'הצג עוד',
	budgetExecutionPhase: 'תקציב עבור כל האובייקטים בתוך {0}',
	details: 'פרטים',
	unallocated: 'לא הוקצה',
	none: 'אף אחד',
	thousands: 'אלפים',
	millions: 'מיליונים',
	lakhs: 'Lakhs',
	crores: 'Crores',
	budgetObjectName: 'שם אובייקט תקציב',
	editActivityCodes: 'ערוך קודי פעילות',
	save: 'שמור',
	send: 'Send',
	cancel: 'בטל',
	searchActivityCodes: 'חפש קודי פעילות',
	noActivityCodesAvailable: 'אין קודים זמינים לפעילות',
	select: 'בחר',
	engagementCode: 'קוד התקשרות',
	engagementCodeName: 'Engagement code name',
	activityCode: 'קוד פעילות',
	activityCodeDescription: 'תיאור קוד פעילות',
	searchActivityCodesPlaceholderText: 'חפש קודי פעילות',
	addMember: 'הוסף חבר',
	closeLabel: 'Close',
	cancelLabel: 'בטל',
	seachInputRequired: 'חפש קלט שנדרש',
	nameOrEmail: 'שם או דוא"ל',
	emailForExternal: 'דואל',
	noRecord: 'לא נמצאו תוצאות',
	userSearchPlaceholder: 'הזן שם או דוא"ל ולחץ Enter כדי לראות תוצאות.',
	userSearchPlaceholderForExternal: 'הזן דוא"ל ולחץ Enter כדי לראות תוצאות.',
	clearAllValues: 'נקה את כל הערכים',
	clear: 'Clear',
	inValidEmail: 'אנא הזן דוא"ל חוקי',
	invalidClientCode: 'קוד לקוח לא חוקי',
	railSearchText: 'חפש',
	open: 'פתח',
	remove: 'הסר',
	leave: 'לעזוב',
	delete: 'מחק',
	markAsCompleted: 'סמן כהושלם',
	budgetedHours: 'שעות מתוקצבות',
	forecastedHours: 'שעות צפויות',
	actualHours: 'שעות בפועל',
	ftaVariance: 'שונות FTA (שונות מול בפועל)',
	ftaVarianceTooltip: 'תחזית לשונות מול בפועל',
	usedHours: 'שעות בשימוש',
	etcHours: 'שעות ETC',
	createProjectCard: 'צור פרוייקט',
	plusClients: '+ {0} לקוחות',
	plusCodes: '+ {0} קודי לקוח',
	clientNames: 'שמות לקוחות:',
	clientName: 'שם לקוח:',
	clientNameLabel: 'Client name',
	clientCodes: 'קודי לקוח:',
	clientCodeCard: 'קוד לקוח:',
	financialAnalysis: "ניתוח פיננסי",
	billingExpenses: 'חיוב והוצאות',
	independence: "אי תלות",
	timeChargedCanvasIndependenceStatus: 'Overall Project Independence Status by EY Canvas and Financial Code',
	independenceStatusFromCanvasLabel: 'Independence status from EY Canvas',
	independenceRequired: 'Independence required',
	validatedCanvas: 'Validated in EY Canvas',
	notInvited: 'Not invited',
	notApplicable: 'Not applicable',
	incomplete: 'Incomplete',
	other: "Other",
	financialCodesDisplayed: "Financial codes displayed",
	independenceStatusChangeReasonLabel: "Change status",
	independenceStatusChangeReasonDescription: "Select completion reason for selected team member",
	changeReasonLabel: 'Reason',
	clarificationLabel: 'Clarification (optional)',
	characterCount: '{0} of 200 characters',
	expandAll: "Expand all",
	collapseAll: "Collapse all",
	canvasEngagements: "EY Canvas engagements",
	independenceCompleted: 'Independence completed',
	engagementName: 'Engagement name',
	engagementIndependenceStatus: 'By engagement independence status',
	noAssociatedClients: 'No associated client',
	noCanvasEngagementsIdentified: 'No EY Canvas engagements identified',
	placeholderForSearch: 'Search Team Member',
	exportToExcel: 'Export to Excel',
	all: 'All',
	updateSelected: 'Update selected',
	updateAll: 'Update all',
	customizeTable: 'Customize table',
	canvasEngagementName: 'EY Canvas engagement name',
	displayBy: 'הצג נתונים לפי',
	financialDetails: 'נתונים פיננסיים',
	actualHoursToDate: 'שעות בפועל עד היום',
	byWeekEndingDate: 'לפי תאריך סיום בשבוע',
	ClickAndDrag: 'לחץ וגרור אזור בתרשים בכדי להגדיל את התצוגה',
	etc: 'זמן משוער להשלמת',
	auditProgress: 'EY Canvas progress',
	tasksAndMilestones: 'משימות ואבני דרך',
	milestonesOverdue: 'תאריך יעד סיום שלבים בביקורת (Milestones overdue)',
	milestoneOverdue: 'תאריך יעד סיום שלבים בביקורת (Milestones overdue)',
	inProgress: 'מתבצע',
	inReview: 'בסקירה',
	Complete: 'המשימות למענה  בביקורת הושלמו',
	assignments: 'משימות לביצוע',
	assignment: 'משימות לביצוע',
	assignmentsOverdue: 'משימות שתאריך היעד שלהן חלף',
	assignmentOverdue: 'משימות שתאריך היעד שלהן חלף',
	overdue: 'תאריך היעד חלף',
	requestOverdue: 'בקשה באיחור',
	requestsOverdue: 'בקשות באיחור',
	total: 'סך הכול',
	complete: 'המשימות למענה  בביקורת הושלמו',
	closed: 'סגור',
	Unassigned: 'Unassigned',
	unassigned: 'unassigned',
	sent: 'נשלח',
	totalTask: 'סך הכל משימות',
	collaboration: 'שיתוף פעולה',
	received: 'התקבל',
	accepted: 'התקבל',
	outstanding: 'יוצא מן הכלל (outstanding)',
	unsentDrafts: 'טיוטות שלא נשלחו',
	draft: 'טיוטה',
	drafts: 'טיוטות',
	returned: 'returned',
	draftRequests: 'טיוטת בקשות',
	percent: 'אחוז',
	preparer: 'מכין',
	reviewer: 'סוקר',
	NoDataForSelectedOptions: 'No information available for the selected options.',
	NoAssignmentDataForSelectedOptions: 'Engagement is not using the Assignment feature',
	NoCollabDataForSelectedOptions: 'תיק הביקורת אינו משתמש באופציית שיתוף הפעולה עם הלקוחות (Collaboration)',
	tasks: 'משימות',
	totalTasks: 'סה"כ משימות',
	requests: 'בקשות',
	requestSent: 'הבקשות נשלחו',
	requestsSent: 'הבקשות נשלחו',
	expandDetails: 'הרחב פרטים',
	onlyProjectAdministratorsCanEdit: 'רק מנהלי פרויקטים יכולים לערוך',
	onlyProjectAdministratorsCanDelete: 'רק מנהלי פרויקטים יכולים למחוק פרויקטים',
	userOptions: 'אפשרויות משתמש',
	userOptionsDropdown: {
		userSettings: 'הגדרות משתמש',
		delegateAccess: 'נהל מיופי כוח',
		privacyNotice: 'Privacy notice',
		signOut: 'התנתקות'
	},
	delegateToInstruction: 'הקצו את הגישה לעמיתים, בכדי שהם יוכלו לאמת את קודי ההתקשרות בשמכם. מיופי כוח אלה יוכלו לאמת את כל קודי ההתקשרויות אליהם יש לך גישה.',
	delegateFromInstruction: 'המשתמשים הבאים האצילו את זכויותיהם לאמת קודי התקשרות.',
	delegateAccess: 'נהל מיופי כוח',
	addDelegates: 'הוסף מיופי כוח',
	addAnother: 'הוסף מיופה כוח חדש',
	hideMyDelegate: 'הסתר את מיופי הכוח שלי',
	showMyDelegate: 'הצג את מיופי הכוח שלי',
	duplicateUser: 'מיופה כוח כבר נוסף',
	informationRequired: 'המידע הזה נדרש',
	delegateTo: 'הוקצה ל',
	delegateFrom: 'הוקצה על ידי',
	noDelegatesAdded: 'לא נוספו מיופי כוח.',
	noDelegationReceived: 'לא התקבלה הקצאה.',
	removeDelegateMessgae: 'האם אתה בטוח שברצונך להסיר את מיופי הכוח האלו? לאחר הסרתם, הם כבר לא יוכלו לאמת את קודי ההתקשרות בשמך.',
	removeDelegateTitle: 'הסר מיופה כוח',
	delegate: 'העבר משימה',
	saveAndClose: 'שמור וסגור',
	resetZoom: 'Reset zoom',
	exportData: 'Export data',
	rankCode: 'Rank code',
	userGui: 'User GUI',
	email: 'Email',
	globalAnsr: 'Global ANSR',
	globalCost: 'Global cost',
	globalMargin: 'Global margin',
	localAnsr: 'Local ANSR',
	localCost: 'Local cost',
	localMargin: 'Local margin',
	weekEnding: 'Week ending',
	welcomeToEconomics: 'Welcome to the EY Canvas Economics ',
	adminPortal: 'administrative portal',
	home: 'Home',
	enterFirstNameText: 'Enter first name, last name or email address of user and press enter to search',
	addBtn: 'הוסף',
	cancelBtn: 'Cancel',
	close: 'Close',
	selectRole: 'Role',
	upsText: 'Ups!',
	sufficientRightsToAccess: 'You do not have sufficient rights to access this page',
	detailedInformation: 'Detailed information may vary from summary data presented due to timing differences of when data is made available.',
	noResultFound: 'No results match the search criteria',
	loading: 'Loading...',
	search: 'חפש',
	softwareUpdate: 'Software updates',
	updateLater: 'Update later',
	updateNow: 'Update now',
	updateMsg: 'Software updates are available for EY Canvas Economics. Select Update Now to download and install the updates. The page will be refreshed.',

	eycanvasEngagements: 'EY Canvas engagements',
	eycanvasEngagement: 'EY Canvas engagement',
	expandView: 'Expand view',
	noFinancialCodesDisplay: 'No financial codes to display',
	expand: 'הרחב',
	collapse: 'Collapse',
	bulkSendIndependenceLabel: 'Bulk send independence confirmation',
	independenceStatusInviteUserLabel: 'Add internal team member as Independence only',
	independenceStatusInviteUserDescription: "Identify the role of the team member below. This user will be added to {0} Canvas engagement with the 'Independence only' restrictions and will be notified to complete their Independence.",
	clickToInviteUser: 'to send independence confirmation',
	click: 'Click',
	invitePending: 'Invite pending',
	engagementRolePlaceholder: 'Engagement role',
	engagementRoleRequiredErrorMessage: 'Please select the engagement role for the selected team member',
	engagementInvitationSuccessToastMessage: 'You have successfully sent the independence confirmation(s).',
	engagementInvitationFailureToastMessage: 'Failed to send the independence confirmation(s), Please retry. If issue persists, reach out to the Help desk.',
	independenceInviteConfirmationMessage: 'Independence confirmation has been sent. Response is pending.',
	engagementRoleRequiredOverAllErrorMessage: 'An engagement role has not been selected for one or more users. Select the engagement role from the drop down to proceed with sending the Independence confirmation.',
	administrativeContractor: 'Administrative contractor',
	notAvailable: 'Not Available',
	allocation: 'Allocation',
};

export const errors = {
	default: 'התרחשה שגיאה. אנא צור קשר עם התמיכה הטכנית.',
	102: 'פרויקט לא חוקי.',
	106: 'אישור RBAC נדחה.',

	1001: 'המשתמש לא נמצא.',
	1002: 'בקשה לקבלת משתמש נכשלה.',
	1003: 'ממשק המשתמש (User GUI) לא יכול להיות לא חוקי (null).',
	1004: 'הבקשה אינה יכולה להיות null.',
	1005: "לא ניתן היה ליצור משתמש מכיוון שמשתמש עם אותו קוד עובד (GUI) כבר קיים",
	1006: 'נמצא יותר ממשתמש אחד עם אותו קוד עובד (GUI)',
	1007: 'המשתמש אינו פעיל. אנא רענן את הדף ונסה שוב. אם השגיאה נמשכת, אנא פנה לתמיכה הטכנית (Help Desk).',
	1008: 'תבנית המספר שנבחרה אינה תבנית חוקית. אנא רענן את הדף ונסה שוב. אם השגיאה נמשכת, אנא פנה לתמיכה הטכנית (Help Desk).',
	1009: 'תבנית העיגול שנבחרה אינה תבנית חוקית. אנא רענן את הדף ונסה שוב. אם השגיאה נמשכת, אנא פנה לתמיכה הטכנית (Help Desk).',
	1010: 'תבנית המטבע שנבחרה אינה תבנית חוקית. אנא רענן את הדף ונסה שוב. אם השגיאה נמשכת, אנא פנה לתמיכה הטכנית (Help Desk).',
	1011: 'תבנית התאריך שנבחרה אינה תבנית חוקית. אנא רענן את הדף ונסה שוב. אם השגיאה נמשכת, אנא פנה לתמיכה הטכנית (Help Desk).',
	1012: 'השפה שנבחרה אינה שפה חוקית. אנא רענן את הדף ונסה שוב. אם השגיאה נמשכת, אנא פנה לתמיכה הטכנית (Help Desk).',
	1013: 'השם הפרטי הינו קצר מידי או ארוך מידי. אנא נסה שוב.',
	1014: 'שם המשפחה הינו קצר מידי או ארוך מידי. אנא נסה שוב.',
	1015: 'תבנית המספר השלילי שנבחרה אינה תבנית חוקית. אנא רענן את הדף ונסה שוב. אם השגיאה נמשכת, אנא פנה לתמיכה הטכנית (Help Desk).',
	1016: "לא ניתן היה לעדכן את המשתמש מכיוון שהוא לא קיים.",
	1017: 'אירעה שגיאה בעת קבלת העדפות משתמש. בקשת ה- API נכשלה.',
	1018: 'אירעה שגיאה בעת יצירת המשתמש. בקשת ה- API נכשלה.',
	1019: 'אירעה שגיאה בעת עידכון העדפות המשתמש. בקשת ה- API נכשלה.',
	1020: 'המשתמש אינו פעיל. רענן את הדף ונסה שוב. אם השגיאה נמשכת, פנה לתמיכה הטכנית.',
	1021: 'ערך הנושא שנבחר אינו ערך חוקי. רענן את הדף ונסה שוב. אם השגיאה ממשיכה, פנה לתמיכה הטכנית.',
	1022: 'ערך המטבע שנבחר אינו ערך חוקי. רענן את הדף ונסה שוב. אם השגיאה ממשיכה, פנה לתמיכה הטכנית.',
	1023: 'למשתמש אין הרשאה להסיר את חבר הצוות המבוקש מהפרויקט.',
	1024: 'אירעה שגיאה בעת יצירת משתמש מיופה הכוח. קריאת ה- API נכשלה.',
	1025: 'רשימת המשתמשים מיופי הכוח אינה יכולה להיות ריקה.',
	1026: 'שם המשתמש ארוך או קצר מדי.',
	1027: 'מספר העובד (GUI) של המשתמש אינו חוקי.',
	1028: 'כתובת האימייל של המשתמש ארוכה או קצרה מדי.',
	1029: 'מזהה משתמש (User ID) לא יכול להיות ריק.',
	1030: 'שם המשתמש לא יכול להיות ריק.',
	1031: 'כתובת הדוא"ל של המשתמש לא יכולה להיות ריקה.',
	1032: 'המשתמש אינו חלק מרשימת מיופי הכוח להסרת הגישה.',
	1033: 'המשתמש אינו חלק מרשימת מיופי הכוח להסרת הגישה.',
	1034: 'המשתמש כבר חלק מרשימת מיופי הכוח.',
	1035: 'מספר משתמש מזוהה (User ID) אינו מתאים. נסה שוב עם מספר משתמש מזוהה נכון.',
	1036: 'משתמש מחובר לא יכול להיות חלק מהרשימה. בבקשה נסה שוב מאוחר יותר.',
	1040: 'You do not have administrator rights. Please contact the help desk.',

	7001: "הבקשה לנתוני תיק הביקורת ('Engagements metadata) נכשלה.",
	7006: 'לא ניתן לגשת ל- EY Canvas כעת. רענן את הדף ונסה שוב. אם השגיאה נמשכת, אנא פנה לתמיכה הטכנית (Help Desk).',

	8003: 'שגיאה בעת קבלת פרטי תיק הביקורת מה- CDS API.',
	8006: 'לא ניתן לגשת ל- EY Canvas כעת. רענן את הדף ונסה שוב. אם השגיאה נמשכת, אנא פנה לתמיכה הטכנית (Help Desk).',
	8004: 'קוד ההתקשרות לא נמצא. אם זהו קוד מרקורי, ודא שסוג ההתקשרות נכלל. נסה שוב ואם הבעיה ממשיכה, אנא פנה לתמיכה הטכנית.',
	8007: 'Error while getting Engagement Details from CDS API.',
	8008: 'Connection failed. Refresh and try again. If the issue persists, contact the Help desk.',

	9001: 'הבקשה אינה יכולה להיות ריק',
	9002: "השדה 'קוד פרוייקט לקוח' אינו יכול להיות ריק",
	9003: "השדה 'שם פרוייקט' אינו יכול להיות ריק.",
	9004: "השדה 'אחוזים' אינו יכול להיות ריק",
	9005: 'שדה התעריף אינו יכול להיות ריק.',
	9006: 'לתקציב לא משויכת התקשרות נבחרת.',
	9007: 'המזהה הייחודי של תיק הביקורת אינו יכול להיות ריק.',
	9008: 'שם לקוח הביקורת אינו יכול להיות ריק.',
	9009: 'תיאור תיק הביקורת אינו יכול להיות ריק.',
	9010: 'המזהה הייחודי של לקוח תיק הביקורת אינו יכול להיות ריק.',
	9011: 'מערכת תיק הביקורת המקושר אינה יכולה להיות ריק.',
	9012: 'מזהה ייחודי של תיק הביקורת המקושר אינו יכול להיות ריק.',
	9013: 'שם תיק הביקורת המקושר אינו יכול להיות ריק.',
	9014: 'המזהה הייחודי של לקוח ביקורת קשור אינו יכול להיות ריק.',
	9015: 'שם לקוח תיק הביקורת הקשור אינו יכול להיות ריק.',
	9016: 'תיק הביקורת הקשור שנוסף על-ידי אינו יכולה להיות ריק.',
	9017: 'One or more EY Canvas engagements are invalid.',
	9018: 'One or more Related engagement Codes are invalid.',
	9019: "אחוז הפרוייקטים צריך להיות גדול מאפס.",
	9020: "אחוז הפרוייקטים לא צריך להכיל יותר משתי ספרות עשרוניות.",
	9021: "שיעור הפרוייקטים צריך להיות גדול מאפס.",
	9022: 'מזהה פרוייקט אינו חוקי',
	9023: 'Get call for financial analysis failed.',
	9024: 'פרטי הפרוייקט לא נמצאו.',
	9025: 'קבלת קריאה לכותרת נכשלה.',
	9026: 'No results match the search criteria.',
	9027: 'סוג צבירה לא חוקי.',
	9028: 'למשתמש הנוכחי אין גישה לפרוייקט.',
	9029: 'פרטי החיוב של הפרוייקט לא נמצאו.',
	9030: "Project Financial Filters not found.",
	9031: "A user's name is either too long or too short.",
	9032: "A user's GUI is invalid.",
	9033: "A user's email address is either too long or too short.",
	9034: 'At least one team member should have project administrator role.',
	9035: 'אתה המשתמש האחרון הפעיל של מנהל הפרויקט בפרויקט. מחק את הפרויקט בכדי להסיר אותו מדף הפתיחה (Landing Page) שלך. אם אינך מצליח למחוק את הפרויקט, צור קשר עם התמיכה הטכנית.',
	9036: 'Please remove some EY Canvas Engagement because the quantity exceeds the {0}.',
	9037: 'Please remove some team members because the quantity exceeds the {0}.',
	9038: 'Please remove some Engagement codes because the quantity exceeds the {0}.',
	9039: 'מספר משתמשי הפרויקט חייב להיות גדול מאפס.',
	9040: 'Unvalidated Financial Codes must not be null or empty strings, and their length cannot surpass 50 characters.',
	9041: 'מספר מזהה של הפרויקט לא יכול להיות ריק.',
	9042: 'לא ניתן להשלים את המחיקה. נסה שוב ואם השגיאה נמשכת, פנה לתמיכה הטכנית.',
	9043: 'למשתמש הנוכחי אין גישה לערוך פרויקט.',
	9044: 'Project Financial Details call failed.',
	9045: 'Project status is not valid.',
	9046: 'Project user status is not valid.',
	9047: 'Invalid project user role.',
	9048: 'Project name should be within 500 characters.',
	9049: 'Project user first name cannot be empty.',
	9050: 'Project user last name cannot be empty.',
	9051: 'Project user GUI cannot be empty.',
	9052: 'Project user email cannot be empty.',
	9053: 'Project user admin flag cannot be empty.',
	9054: 'Priviledged account cannot be added as project user.',
	9055: 'Project Expense Filters not found.',
	9056: 'Project indepedence patch request body cannot be empty.',
	9058: 'Financial codes is invalid.',
	9063: 'Independence complete has invalid rationale value.',
	9064: 'Independence complete type has invalid value.',
	9065: 'Project Expense Filters not found.',
	9066: 'Number of engagement ids linked to the project is greater than the maximum allowed number.',
	9067: 'Invalid patch operation.',
	9068: 'Some user already updated the status, refresh the page to view the latest status.',
	9069: 'Independence patch API failed.',
	9070: 'Duplicate financial codes associated to canvas engagement.',
	9071: 'Only single financial codes associated to canvas engagement can be marked as primary code.',
	9072: 'Primary financial codes associated to canvas engagements is invalid.',
	9073: 'Duplicate unvalidated financial codes.',
	9074: 'Duplicate users.',
	9075: 'A user Email is invalid.',
	9076: 'Engagement user creater request body cannot be empty.',
	9077: 'Engagement user create request has duplicate users.',
	9078: 'Engagement user role is invalid.',
	9079: 'Invalid canvas engagement.',
	9080: 'Engagement not mapped to project.',
	9081: 'Engagement user creation request failed.',
	9082: 'Session has been timed out due to inactivity. Refresh the page and try again. If the issue persists, contact the Help Desk.',

	/*Admin error codes*/
	14001: 'User not found',
	14002: 'Admin User call failed',
	14003: 'Admin user found is InActive',
	14004: 'Admin user creation failed',
	14005: 'The first name is either too short or too long. Please try again',
	14006: 'The last name is either too short or too long. Please try again',
	14007: 'Administrator role id is invalid',
	14008: 'The selected user is already an administrator. Please review.',
	14009: 'Admin user search call failed',
	14010: 'User gui cannot be empty',
	14011: 'User gui must be greater than zero',
	14012: 'User id is not valid. Please try again',
	14013: 'Email address is not valid. Please try again',
	14014: 'Logged in user is not same as admin user',
	14015: 'Admin project search call failed',
	14016: 'Admin user already exists but is InActive',
	14017: 'Admin can only be priviledged user account',
	14018: 'Administrator role id cannot be empty.',
	14019: 'Logged in user is not system admin.',
	14020: 'Invaid requestor privileged account.',
	14021: 'Admin can only be priviledged user account.',
	14023: 'Error removing existing admin roles.',
	14024: 'Error adding updated admin roles.',
	14025: 'Admin user id cannot be empty.',

	/*PAANS error codes*/
	15001: 'The EY Policy Authoring, Approvals and Notification Service​ is unavailable at this time.  We are unable to confirm if all relevant policies have been completed.  If you have not reviewed the relevant policies, refresh the page and try again.  If the issue persists, contact the Help Desk.'
};
export const roundingOptions = [{
	value: 'none',
	label: 'אף אחד'
},
{
	value: 'thousands',
	label: 'באלפים'
},
{
	value: 'millions',
	label: 'במיליונים'
},
{
	value: 'lakhs',
	label: 'ב- Lakhs'
},
{
	value: 'crores',
	label: 'ב- Crores'
}
];

export const displayLanguages = [{
	displayLanguageId: 1,
	label: 'אנגלית',
	value: 'en-us'
},
{
	displayLanguageId: 4,
	label: 'צרפתית',
	value: 'fr-ca'
},
{
	displayLanguageId: 5,
	label: 'ספרדית',
	value: 'es'
},
{
	displayLanguageId: 7,
	label: 'פורטוגזית',
	value: 'pt-br'
},
{
	displayLanguageId: 8,
	label: 'יפנית',
	value: 'ja'
},
{
	displayLanguageId: 9,
	label: 'Chinesezh-cn',
	value: 'zh-cn'
},
{
	displayLanguageId: 10,
	label: 'Chinesezh-tw',
	value: 'zh-tw'
},
{
	displayLanguageId: 11,
	label: 'עברית',
	value: 'he'
},
{
	displayLanguageId: 12,
	label: 'קוריאנית',
	value: 'ko'
},
];

export const numberFormats = [{
	value: '1,234,567,890',
	label: 'סגנון מספר 1',
	title: '1,234,567,890'
},
{
	value: '1.234.567.890',
	label: 'סגנון מספר 3',
	title: '1.234.567.890'
},
{
	value: '1,23,45,67,890',
	label: 'סגנון מספר 7',
	title: '1,23,45,67,890'
},
{
	value: '1 234 567 890',
	label: 'סגנון מספר 2',
	title: '1 234 567 890'
}
];

export const dateFormats = [{
	value: 'MM/dd/yyyy',
	label: 'MM/DD/YYYY'
},
{
	value: 'dd/MM/yyyy',
	label: 'DD/MM/YYYY'
},
{
	value: 'yyyy/MM/dd',
	label: 'YYYY/MM/DD'
}
];

export const negativeNumberFormats = [{
	value: '(1.1)',
	label: '(1.1)'
},
{
	value: '-1.1',
	label: '-1.1'
},
{
	value: '- 1.1',
	label: '- 1.1'
},
{
	value: '1.1-',
	label: '1.1-'
},
{
	value: '1.1 -',
	label: '1.1 -'
}
];

export const currencyFormats = [{
	value: 'global',
	label: 'Global'
},
{
	value: 'מקומי',
	label: 'מקומי'
}
];

export const themeOptions = {
	light: 'בהיר',
	dark: 'כהה'
};

export const currencyOptions = {
	global: 'Global',
	local: 'מקומי'
};

export const currencyDisplayOptions = [{
	value: 'Global',
	label: 'Global'
},
{
	value: 'Local',
	label: 'מקומי'
}
];

export const statusValues = [{
	isActive: true,
	label: 'Active'
},
{
	isActive: false,
	label: 'Inactive'
}
];

export const financialOptions = {
	serviceLine: 'מחלקה',
	subServiceLine: 'קו שירות משנה (Sub-service Line)',
	teamMember: 'חבר צוות',
	rank: 'דַרגָה'
};

export const roles = {
	1: 'השותף האחראי על תיק הביקורת',
	2: 'השותף האחראי על תיק הביקורת',
	3: 'ED',
	4: 'שותף',
	5: "סניור מנג'ר",
	6: "מנג'ר",
	7: 'סניור',
	8: 'מתמחה',
	9: 'מתמחה',
	10: 'שותף מלווה EQR',
	11: 'שותף אחר',
	12: 'GDS - Staff',
	13: 'ייעוץ (ITRA, TAS, הון אנושי או אחר)',
	14: 'TAX',
	15: 'שירותי תמיכה ניהוליים',
	16: 'יועץ משפטי',
	17: 'סוקר AQR',
	21: 'אחראי על הביקורת הפנימית',
	22: 'צוות ביקורת פנימית',
	23: 'רגולטור',
	24: 'אחר (למשל בדיקה נאותות)',
	25: 'משרד',
	26: 'אזור',
	27: 'תעשייה',
	28: 'National',
	29: 'Global',
	30: 'GDS - Senior',
	31: 'GDS - Manager'
};

export const serviceLines = [{
	value: 0,
	label: 'כל קווי השירות SL'
},
{
	value: 1,
	label: 'Advisory'
},
{
	value: 2,
	label: 'Assurance'
},
{
	value: 3,
	label: 'GCO'
},
{
	value: 4,
	label: 'TAS'
},
{
	value: 5,
	label: 'TAX'
},
{
	value: 6,
	label: 'אחרים'
}
];

export const serviceLinesByServiceLineCode = [{
	code: 'Not available',
	label: 'Not available'
},
{
	code: null,
	label: 'Allocation'
},
{
	code: 'ASU',
	label: 'Assurance'
},
{
	code: 'TAS',
	label: 'Strategy and Transactions'
},
{
	code: 'TAX',
	label: 'TAX'
},
{
	code: 'ADV',
	label: 'Consulting'
},
];

export const userRanks = [{
	id: '11',
	name: 'שותף'
},
{
	id: '12',
	name: 'שותף'
},
{
	id: '13',
	name: 'ED'
},
{
	id: '21',
	name: 'Sr. Manager'
},
{
	id: '32',
	name: "מנג'ר"
},
{
	id: '36',
	name: 'Tax Manager'
},
{
	id: '4',
	name: 'קבלן'
},
{
	id: '41',
	name: 'Senior 3'
},
{
	id: '42',
	name: 'סניור'
},
{
	id: '43',
	name: 'Staff 2'
},
{
	id: '44',
	name: 'מתמחה'
},
{
	id: '45',
	name: 'Senior 2'
},
{
	id: '46',
	name: 'Staff 3'
},
{
	id: '49',
	name: 'חָבֵר'
},
{
	id: '5',
	name: 'Administrative contractor'
},
{
	id: '51',
	name: 'מתמחה'
},
{
	id: '52',
	name: 'Admin Support'
},
{
	id: '53',
	name: 'עובד חדש (CBS)'
},
{
	id: '55',
	name: 'Admin Lead'
},
{
	id: '56',
	name: 'Admin Advanced'
},
{
	id: '57',
	name: 'Admin Intermediate'
},
{
	id: '58',
	name: 'Admin Entry'
},
{
	id: '61',
	name: 'Director'
},
{
	id: '62',
	name: 'Associate Director'
},
{
	id: '63',
	name: 'Assistant Director'
},
{
	id: '64',
	name: 'Supervising Associate'
},
{
	id: '65',
	name: 'Sr. Associate'
},
{
	id: '66',
	name: 'חָבֵר'
},
{
	id: 'Not available',
	name: 'Not available'
},
{
	id: null,
	name: 'Allocation'
},
];

export const financialAnalysis = {
	noResultFound: 'לא נמצאו תוצאות עבור האפשרויות שנבחרו',
	allServiceLines: 'כל קווי השירות SL',
	allSubServiceLines: 'כל תתי המחלקות (SSL)',
	allMembers: 'כל חברי הצוות',
	allAvailable: 'הכל זמין',
	allAdded: 'כולם נוספו',
	selectAll: 'בחר הכל',
	noResult: 'לא נמצאו תוצאות',
	noneSelected: 'לא נבחר כלום',
	clearAllSeleted: 'נקה # נבחר',
	showSelected: 'הצג את הפריטים שנבחרו',
	allRanks: 'כל הדרגות'
};

export const independenceStatus = [{
	value: 1,
	label: 'Incomplete - Not invited'
},
{
	value: 2,
	label: 'Incomplete - In progress'
},
{
	value: 3,
	label: 'Completed - Other'
},
{
	value: 4,
	label: 'Completed - Validated In EY Canvas'
}
];

export const eycanvasIndependenceStatus = [{
	value: 1,
	label: 'Incomplete'
},
{
	value: 2,
	label: 'No Matters Identified'
},
{
	value: 3,
	label: 'Matter Identified - Pending Action'
},
{
	value: 4,
	label: 'Matter Resolved - Denied Access'
},
{
	value: 5,
	label: 'Matter Resolved - Granted Access'
},
{
	value: 6,
	label: 'Not Applicable'
},
{
	value: 7,
	label: 'Restored'
},
{
	value: 8,
	label: 'Override'
},
{
	value: 9,
	label: 'Prior - No Matters Identified'
},
{
	value: 10,
	label: 'Prior - Matter Identified - Pending Action'
},
{
	value: 11,
	label: 'Prior - Matter Resolved - Granted Access'
},
{
	value: 12,
	label: 'Prior - Matter Resolved - Denied Access'
}
];

export const eycanvasIndependenceStatusAvailableOnUI = [{
	value: 1,
	label: 'Incomplete'
},
{
	value: 2,
	label: 'No Matters Identified'
},
{
	value: 3,
	label: 'Matter Identified - Pending Action'
},
{
	value: 4,
	label: 'Matter Resolved - Denied Access'
},
{
	value: 5,
	label: 'Matter Resolved - Granted Access'
},
{
	value: 6,
	label: 'Not Applicable'
},
{
	value: 7,
	label: 'Restored'
},
{
	value: 8,
	label: 'Override'
},
{
	value: 9,
	label: 'Prior - No Matters Identified'
},
{
	value: 11,
	label: 'Prior - Matter Resolved - Granted Access'
},
{
	value: 12,
	label: 'Prior - Matter Resolved - Denied Access'
},
{
	value: 13,
	label: 'Not Invited'
}
];

export const availableUserRoles = [{
	value: 1,
	label: 'Partner in Charge',
	displayOrder: 9
},
{
	value: 2,
	label: 'Engagement Partner',
	displayOrder: 8
},
{
	value: 3,
	label: 'Executive Director',
	displayOrder: 5
},
{
	value: 4,
	label: 'Principal',
	displayOrder: 6
},
{
	value: 5,
	label: 'Senior Manager',
	displayOrder: 4
},
{
	value: 6,
	label: 'Manager',
	displayOrder: 3
},
{
	value: 7,
	label: 'Senior',
	displayOrder: 2
},
{
	value: 8,
	label: 'Staff',
	displayOrder: 1
},
{
	value: 10,
	label: 'Engagement Quality Reviewer',
	displayOrder: 10
},
{
	value: 11,
	label: 'Other Partner',
	displayOrder: 7
},
{
	value: 12,
	label: 'GDS - Staff',
	displayOrder: 13
},
{
	value: 16,
	label: 'General Counsel',
	displayOrder: 12
},
{
	value: 17,
	label: 'Audit Quality Reviewer',
	displayOrder: 11
},
{
	value: 30,
	label: 'GDS - Senior',
	displayOrder: 14
},
{
	value: 31,
	label: 'GDS - Manager',
	displayOrder: 15
}
]

export const employmentStatusFilter = [{
	value: 'A',
	label: 'Active'
},
{
	value: 'L,P,U',
	label: 'Leave of absence'
},
{
	value: 'D,R,T',
	label: 'Terminated'
}
]

export const employmentStatus = [{
	value: 'A',
	label: 'Active'
},
{
	value: 'D',
	label: 'Terminated'
},
{
	value: 'L',
	label: 'Leave of absence'
},
{
	value: 'T',
	label: 'Terminated'
},
{
	value: 'P',
	label: 'Leave of absence'
},
{
	value: 'R',
	label: 'Terminated'
},
{
	value: 'U',
	label: 'Leave of absence'
},
]

export const independenceStatusDropdown = [{
	label: 'Incomplete',
	options: [{
		value: 1,
		label: 'Incomplete - Not invited'
	},
	{
		value: 2,
		label: 'Incomplete - In progress'
	}
	]
},
{
	label: 'Complete',
	options: [{
		value: 3,
		label: 'Completed - Other'
	}
	]
}
];

export const customizedTableOptions = [{
	id: 2,
	label: 'EY Canvas independence status'
},
{
	id: 3,
	label: 'Member firm'
},
{
	id: 4,
	label: 'Country'
},
{
	id: 5,
	label: 'Hours charged'
},
{
	id: 6,
	label: 'Overall independence status'
},
{
	id: 7,
	label: 'Confirmation date'
},
{
	id: 8,
	label: 'Employment Status'
},
{
	id: 9,
	label: 'Updated by'
},
{
	id: 10,
	label: 'Updated date'
}
];

export const independenceStatusChangeReasons = [{
	value: 1,
	label: 'Completed outside of EY Canvas - No Matters Identified',
	isDisplayed: true
},
{
	value: 7,
	label: 'Completed outside of EY Canvas - Matters Identified',
	isDisplayed: true
},
{
	value: 8,
	label: 'Completed outside of EY Canvas - Matters Resolved',
	isDisplayed: true
},
{
	value: 2,
	label: 'Always a covered person',
	isDisplayed: true
},
{
	value: 3,
	label: 'No longer with the Firm',
	isDisplayed: true
},
{
	value: 4,
	label: 'Leave of absence',
	isDisplayed: true
},
{
	value: 5,
	label: 'Terminated',
	isDisplayed: false
},
{
	value: 6,
	label: 'אחרים',
	isDisplayed: false
}
];

export const common = {
	selected: 'המשתמש שנבחר',
	cancel: 'בטל',
	checkbox: {
		selectAllOn: 'בחר הכל',
		selectAllOff: 'בטל את הבחירה בכולם'
	},
	clear: 'Clear',
	close: 'Close',
	nav: {
		projectName: 'Project name'
	},
	pagination: {
		show: 'הצג',
		iconHover: {
			first: 'הדף הראשון',
			previous: 'הדף הקודם',
			next: 'הדף הבא',
			last: 'הדף האחרון'
		}
	},
	search: {
		clear: 'נקה חיפוש',
		buttonTitle: 'חפש',
		placeholder: 'חפש',
		noResultsPlaceholder: 'לא נמצאו תוצאות'
	},
	table: {
		remove: 'הסר',
		noDataPlaceholder: 'אין נתונים זמינים',
		noResultsPlaceholder: 'לא נמצאו תוצאות'
	},
	toggleSwitch: {
		no: 'לא',
		yes: 'כן'
	},
	wizard: {
		next: 'המשך',
		back: 'חזור',
		finish: 'סיים'
	},
	unsavedChanges: 'Unsaved changes',
	unsavedChangesDescription: 'You have unsaved changes that will be lost if you choose to continue. Are you sure you want to undo your changes?'
};

export const project = {
	myProjects: 'הפרוייקטים שלי',
	priorProjects: 'חפש',
	searchForBudgets: 'חפש',
	emptyContainer: 'אין לך שום תקציב פעיל. לחץ "צור תקציב" כדי להתחיל.',
	noResultsFound: 'לא נמצאו תוצאות',
	create: {
		title: 'צור פרוייקט',
		clientCode: 'קוד לקוח',
		clientCodeInfo: 'קודים מסוג Mirror codes אינם מזוהים. השתמש בקוד שהמערכת הפיקה (כלומר Mercury or GFIS).',
		clientName: 'שם הלקוח',
		clientNamePlaceholder: 'הזן קוד לקוח כדי לאתר את שם הלקוח',
		name: 'שם הפרוייקט',
		rate: 'תעריף ברירת מחדל לשעה',
		rateInfo: 'תעריף ברירת מחדל לשעה ישמש לחישוב ערך השעות המתוקצבות. יש לחשב תעריף זה כעמלות שיחויייבו חלקי סך השעות הצפויות.',
		percentage: 'אחוז ה- realization הצפוי',
		percentageInfo: 'אחוז  ה- realization הצפוי יוחל על ערך הזמן של שעות שנגבו ב- Mercury or GFIS.',
		relateEngagementsInstructionalText: 'בחר תיק ביקורת EY Canvas אחד או יותר שישמשו בפרויקט זה. מדדים מתיקי ביקורת אלה יוצגו לצד נתונים פיננסיים. רק תיקי ביקורת נגישים שהינם נגישים כעת יוצגו.',
		selectClientAndWorkspaceInstructionalText: 'בחר לקוח וסביבת עבודה כדי לזהות תיק ביקורת EY Canvas שיהיו קשורוים לפרויקט זה.',
		engagementPanelPlaceholder: 'בחר לקוח וסביבת עבודה כדי להציג תיקי ביקורת מוצעים.',
		engagementPanelNoResultsFound: 'לא נמצאו תוצאות',
		emptyEngagements: 'אין תיקי ביקורת EY Canvas זמינים. צור תיק ביקורת חדש ב- EY Canvas כדי להתחיל.',
		selectClient: 'בחר לקוח',
		selectWorkspace: 'בחר סביבת עבודה',
		selectEngagements: 'בחר התקשרות',
		selectedEngagements: 'תיקי ביקורת שנוספו',
		selectedEngagementError: 'בחר תיק ביקורת אחד או יותר על מנת להמשיך',
		searchEngagements: 'חיפוש תיקי ביקורת',
		searchUsers: 'חיפוש משתמשים',
		engagementLabel: '{0} | מזהה: {1}',
		addBtn: 'הוסף',
		removeBtn: 'הסר',
		clientLbl: 'לקוח',
		engagementCodeLbl: 'קוד התקשרות',
		engagementTypeCodeLbl: 'סוג תיק ביקורת',
		engagementNameLbl: 'שם ההתקשרות',
		engagementId: 'ID',
		addedByLbl: 'נוסף על ידי',
		engagementDescriptionLbl: 'תיאור תיק ביקורת',
		systemLbl: 'מערכת',
		noEngagementsLabel: 'קשר קודי תיק ביקורת לפרויקט זה',
		step4InstTxt: 'בחר קוד התקשרות אחד או יותר שישויך לפרוייקט.',
		relatedEngagementCodesSubtitle: 'קשר קודי תיק ביקורת לפרויקט זה',
		relatedEngagementCodeLink: 'קשר קוד תיק ביקורת מ- Mercury or GFIS. קודים מסוג mirror codes אינם מזוהים.',
		unauthorizedModalHeader: 'משתמש ללא הרשאות',
		unauthorizedText: 'אינך מורשה לקשר',
		allowedUsersText: 'להלן רשימה של אנשים שיכולים לבצע פעולה זו.',
		closeBtn: 'Close',
		validateBtn: 'לאמת',
		relatedEngagementAddLabel: 'קשר קוד תיק ביקורת מ- Mercury or GFIS. קודים מסוג mirror codes אינם מזוהים.',
		todayLbl: 'היום',
		NoEmailMessage: 'לא סופק דוא"ל',
		noEngagementsAdded: 'לא נוספו תיקי ביקורת',
		selectToImport: 'בחר תיק ביקורת EY Canvas לייבוא משתמשים לפרויקט זה.',
		addMember: 'If a user is not active in the EY Canvas engagement, {0} to add them.',
		addedMembers: 'חברים שנוספו',
		employeeName: 'חבר',
		role: 'Role',
		manageTeamInstructionalText: 'בחר חברי צוות פעילים מתיקי הביקורת EY Canvas הקשורים, עקוב אחר התיאור שלהלן כדי להוסיף חברי צוות אחרים שאינם חלק מתיקי הביקורת EY Canvas.',
		currentUser: 'משתמש נוכחי',
		canvasEngagements: 'EY Canvas engagements',
		wizardSteps: [{
			stepName: 'שלב 1',
			stepDescription: 'הזן פרטי פרוייקט',
			active: true
		},
		{
			stepName: 'שלב 2',
			stepDescription: 'Select EY Canvas engagements'
		},
		{
			stepName: 'שלב 3',
			stepDescription: 'ניהול גישה',
			relatedEngagementCodesSubtitle: 'קשר קודי תיק ביקורת לפרויקט זה',
			relatedEngagementCodeLink: 'קשר קוד תיק ביקורת מ- Mercury or GFIS. קודים מסוג mirror codes אינם מזוהים.',
			unauthorizedModalHeader: 'משתמש ללא הרשאות',
			unauthorizedText: 'אינך מורשה לקשר',
			allowedUsersText: 'להלן רשימה של אנשים שיכולים לבצע פעולה זו',
			close: 'Close'
		},
		{
			stepName: 'שלב 4',
			stepDescription: 'תעריף לשעה'
		},
		{
			stepName: 'Step 5',
			stepDescription: 'Associate engagement codes to EY Canvas engagements',
			isExit: true
		}
		],
		ratePerHour: 'תעריף לשעה',
		realizationPercentage: 'אחוז realization'
	},
	stepOne: {
		enterProjectName: 'הזן שם פרוייקט כדי להמשיך'
	},
	stepTwo: {
		addCanvasEngagements: 'Add EY Canvas engagements to the project',
		editCanvasEngagements: 'Edit EY Canvas engagements to the project',
		selectCanvasEngagements: 'EY Canvas engagements that you have access to are displayed.  Select one or more EY Canvas engagements to be included in the project.',
		noCanvasEngagements: 'No EY Canvas engagements available. Proceed to the next step to continue project setup.',
		noCanvasEngagementsSelected: 'No EY Canvas engagements have been selected',
		noSearchResultsFoundLeftRail: 'No results found',
		clientName: 'לקוח',
		workspace: 'סביבת עבודה',
		engagementCode: 'קוד התקשרות',
		canvasEngagementName: 'EY Canvas Engagement',
		changes: 'שינויים',
		tooltipMessages: {
			clientName: 'שם הלקוח',
			clientCode: 'קוד לקוח',
			engagementCode: 'קוד התקשרות',
			engagementDescription: 'שם ההתקשרות',
			workspaceID: 'מזהה סביבת עבודה',
			workspaceDescription: 'שם סביבת העבודה'
		}
	},
	stepThree: {
		editTeamMembers: 'ערוך את חברי הצוות לפרויקט',
		editTeamMembersWhoWillHaveAccess: 'Edit team members who will have access to the project. To add a team member who is not part of the associated EY Canvas engagements, use the search feature on the right-hand side. Project administrators will have the ability to manage the project (e.g., add or remove team members).',
		addTeamMembers: 'הוסף חברי צוות לפרויקט',
		addTeamMembersWhoWillHaveAccess: 'Add team members who will have access to the project. To add a team member who is not part of the associated EY Canvas engagements, use the search feature on the right-hand side. Project administrators will have the ability to manage the project (e.g., add or remove team members).',
		noCanvasEngagementsSelected: 'No EY Canvas engagements have been selected',
		noSearchResultsFoundLeftRail: 'No results found',
		addOtherTeamMembers: 'Add other team members not part of the connected EY Canvas engagements',
		member: 'חבר',
		projectAdministrator: 'מנהל פרויקט',
		clickHere: 'לחץ כאן',
		nameOrEmail: 'שם או דוא"ל',
		addNewMember: 'הוסף',
		firstName: 'שם פרטי',
		lastName: 'שם משפחה',
		inviteAndClose: 'הזמן וסגור',
		inviteAndAddAnother: 'הזמן והוסף נוסף',
		clear: 'Clear'
	},
	stepFour: {
		engagementCode: 'קוד התקשרות',
		clientName: 'לקוח',
		validation: 'סטטוס',
		independenceOnly: 'Independence only',
		noEngagementCodes: 'לא נוספו קודי תיק הביקורת לפרויקט',
		addNewMember: 'הוסף',
		addEngagementManually: 'הוסף קודי תיק הביקורת',
		addEngagementCodes: 'הוסף קודי תיק הביקורת',
		editEngagementCodes: 'ערוך קודי התקשרות',
		validateEngagement: 'Validate all the engagement codes added. Only engagements codes that you have access to in GFIS/Mercury can be validated. If an engagement code is identified as \'Independence only\', details related to this engagement code (such as team members and related hours charged) will be included in the Independence summary of this Economics project but will not be included in the financial related information.',
		informationalMessage: 'עבור מרקורי, כלול את סוג תיק הביקורת כתחילית לקוד תיק הביקורת (למשל, E-12345678)',
		noCanvasEngagements: 'No EY Canvas engagements have been added to the project',
		engagementCodePlaceholder: 'הזן קוד תיק ביקורת',
		validate: 'לאמת',
		engagementCodeRequired: 'קוד תיק ביקורת נדרש',
		searchNoResults: "לא נמצאו תוצאות"
	},
	stepFive: {
		title: 'Associate engagement codes to EY Canvas engagements',
		description: "The primary engagement codes associated to each of the connected EY Canvas engagements are displayed below. To associate additional engagement codes to an EY Canvas engagement, use the below drag and drop functionality.",
		financialCodes: {
			searchButtonTitle: 'Search',
			searchButtonPlaceholder: 'Search by financial engagement code',
			header: 'Engagement codes',
			noRecords: 'No engagement codes identified',
			canvasEngagements: 'EY Canvas engagements',
			noResults: 'לא נמצאו תוצאות'
		},
		canvasEngagements: {
			searchButtonTitle: 'Search',
			clearButtonTitle: 'Clear',
			noResults: 'לא נמצאו תוצאות',
			searchButtonPlaceholder: 'Search by Client or EY Canvas engagement',
			header: 'Clients and engagements',
			noRecords: 'No EY Canvas engagements associated to the project',
			noEngagementCodes: 'No associated engagement codes',
			primary: 'Primary',
			displayUnassociatedEngagements: 'Display EY Canvas engagement(s) with no financial codes associated'
		}
	},
	deleteProject: 'מחק פרויקט',
	deleteDescription: 'האם אתה בטוח שברצונך למחוק את הפרויקט עבור כל המשתמשים?',
	deleteDescText: 'לא ניתן לבטל פעולה זו.',
	delete: 'מחק',
	cancel: 'בטל',
	close: 'Close',
	confirm: 'אשר',
	leaveProject: 'לעזוב',
	leaveDescription: 'האם אתה בטוח שאתה רוצה לעזוב את הפרויקט הזה? הוא ימשיך להיות זמין עבור חברי הצוות שלך.',
	change: 'שינוי',
	changes: 'שינויים'
};

export const users = {
	settings: {
		title: 'הגדרות משתמש',
		firstName: 'שם פרטי',
		lastName: 'שם משפחה',
		displayLanguage: 'שפת התצוגה',
		numberFormat: 'תבנית מספרית',
		negativeNumberFormat: 'תבנית מספר שלילי',
		currencyFormat: 'תבנית מטבע',
		dateFormat: 'תבנית תאריך',
		roundingFormat: 'תבנית עיגול',
		save: 'שמור',
		cancel: 'בטל',
		errorMessageSelect: 'נא בחר ערך.',
		errorMessageInput: 'נא הזן ערך חוקי.',
		isRequired: 'נדרש.',
		preferences: 'העדפות',
		yourDelegates: 'העברת המשימות שביצעת',
		yourDelegatesDescription: 'משתמשים שהענקת להם סמכות לאחזר נתונים פיננסיים/כספיים לקודי תיק ביקורת אליהם יש לך גישה ב- Mercury או ב- GFIS',
		delegationsFromOthers: 'העברת משימות מאחרים',
		delegationsFromOthersDescription: 'משתמשים שהעניקו לך סמכות לאחזר נתונים פיננסיים לתיק ביקורת שיש להם גישה ב- Mercury או ב- GFIS',
		noUsersIdentified: 'לא זוהו משתמשים',
		addADelegate: 'הוספת מיופה כוח',
		theme: 'נושא',
		preferredCurrency: 'מטבע מועדף',
		status: 'סטטוס'
	}
};

export const projectSummary = {
	filter: {
		filterFinancialAuditData: 'סנן לקוחות',
		filter: 'סנן',
		searchPlaceholder: 'חפש',
		searchClearHoverText: 'Clear',
		searchHoverText: 'חפש',
		unvalidated: 'לא מאומת',
		noData: 'No EY Canvas engagement associated',
		noResults: 'לא נמצאו תוצאות',
		noInformationAvailable: 'אין מידע זמין לגבי האפשרויות שנבחרו.',
		independence: "אי תלות",
		noDataFound: 'No data found',
	},
	roundingType: 'עיגול:',
	roundingFormats: {
		none: 'אף אחד',
		thousands: 'באלפים',
		millions: 'במיליונים',
		lakhs: 'ב- Lakhs',
		crores: 'ב- Crores'
	},
	updatedDateType: {
		financialDateLabel: 'Financial data',
		updatedOn: 'updated on',
		canvasDateLabel: 'EY Canvas data'
	},
	keyPerformanceIndicators: {
		noValue: '-',
		totalEngagementRevenue: {
			ter: 'TER',
			actualTER: 'TER בפועל',
			billed: 'מחוייב',
			actualBilling: 'חיוב בפועל',
			totalEngagementRevenue: 'סה"כ הכנסות מתיק הביקורת (שכ"ט + הוצאות)',
			forecastedTER: 'TER צפוי'
		},
		margin: {
			margin: 'מרווח',
			target: 'יעד'
		},
		globalDeliveryService: {
			gds: 'שימוש ב- GDS',
			globalDeliveryService: 'Global Delivery Service'
		}
	},
	currency: 'מטבע',
	globalCurrency: 'Global',
	localCurrency: 'מקומי',
	noDataAvailable: 'אין נתונים זמינים עבור המסננים שנבחרו',
	actualHours: 'שעות בפועל',
	etc: 'ETC',
	ftaVariance: 'שונות FTA (שונות מול בפועל)',
	completedTasks: 'משימות שהושלמו',
	closedAssignments: 'משימות סגורות',
	acceptedRequests: 'בקשות שהתקבלו',
	gDSUsage: 'שימוש ב- GDS',
	summaryHeaderPartner: 'שותף',
	summaryHeaderPpedd: 'PPEDD',
	summaryHeaderExecutive: 'Executive',
	financialProgressCard: {
		financialProgress: 'התקדמות פיננסית',
		financialDetails: 'נתונים פיננסיים',
		ansr: 'ANSR',
		nsr: 'NSR',
		ansrTooltip: 'Adjusted net standard revenue (net fees excluding expenses)',
		nsrTooltip: 'Net standard revenue (individual net standard rates times hours)',
		eafTooltip: 'Engagement adjustment factor',
		cost: 'עלות',
		hours: 'שעות',
		expandDetails: 'הרחב פרטים',
		expand: 'הרחב',
		collapse: 'Collapse',
		collapseDetails: 'Collapse details',
		margin: 'מרווח',
		marginPercentage: 'מרווח',
		rphAcronym: 'RPH',
		cphAcronym: 'CPH',
		mphAcronym: 'MPH',
		eafAcronym: 'EAF',
		actual: 'בפועל',
		budgeted: 'מתוקצב',
		forecasted: 'צפוי',
		ftaVariance: 'שונות FTA (שונות מול בפועל)',
		ftaVarianceTooltip: 'תחזית לשונות מול בפועל',
		rph: 'תעריף לשעה',
		cph: 'עלות לשעה',
		mph: 'מרווח לשעה',
		ansrCost: 'NSR / Cost',
		serviceLine: 'מחלקה',
		subServiceLine: 'קו שירות משנה (Sub-service Line)',
		teamMember: 'חבר צוות',
		totalAnsr: 'Total NSR',
		totalCost: 'עלות כוללת',
		totalHours: 'סה"כ שעות',
		ansrLabelText: 'Net standard revenue',
		rank: 'דַרגָה',
		performanceActuals: 'Performance actuals'
	},
	financialAnalysis: {
		show: 'הצג',
		first: 'ראשון',
		last: 'אחרון',
		previous: 'הקודם',
		next: 'הבא'
	},
	financialFilters: {
		serviceLine: 'מחלקה',
		subServiceLine: 'קו שירות משנה (Sub-service Line)',
		rank: 'דַרגָה',
		teamMember: 'חבר צוות',
		showMore: 'עוד',
		clear: 'Clear',
		clearAll: 'נקה הכל',
		search: 'חפש',
		noResultsPlaceholder: 'אין תוצאות',
		noFiltersAvailable: 'ללא מסננים',
		yes: 'כן',
		no: 'לא',
		tooltip: 'סנן',
		expenseType: 'Expense type',
		allocation: 'Allocation'
	},
	billingAndExpenses: {
		title: 'חיובים בפועל עד כה',
		forecastedTer: 'TER צפוי',
		forecastedTerTooltip: 'Forecasted total engagement revenue (fees + expenses)',
		forecastedBilling: 'חיוב צפוי',
		collected: 'נגבה',
		collectedTooltip: 'Collected / Billed',
		unCollected: 'Uncollected',
		unCollectedTooltip: 'Uncollected / Billed',
		billed: 'Billed (Outstanding)',
		billedTooltip: 'Billed / Forecasted TER',
		billedTotal: 'Billed',
		unbilled: 'טרם חויב',
		unbilledTooltip: 'Unbilled / Forecasted TER',
		engagementCode: 'קוד התקשרות',
		invoiceDate: 'Invoice date',
		currency: 'Currency',
		invoiceNumber: 'Invoice number',
		amount: 'Amount',
		noInformationPlaceholder: 'No information available for the selected options.',
		actualTer: 'Actual TER',
		actualTerTooltip: 'Actual total engagement revenue (fees + expenses)',
		actualExpenseToDate: 'Actual expenses to date',
		displayBy: 'הצג נתונים לפי',
		expenseType: 'Expense type',
		teamMember: 'חבר צוות',
		totalExpenseToDate: 'Total expenses to date',
		expenseTypeColumn: 'Expense type',
		teamMemberColumn: 'Team member',
		globalExpenseAmount: 'Global expense amount',
		localExpenseAmount: 'Local expense amount',
		billingSummary: 'Billing summary',
		billingStatus: 'Billing status',
		billingTER: 'TER',
		serviceLine: 'מחלקה',
		serviceLineColumn: 'Service line',
		rank: 'דַרגָה',
		rankColumn: 'Rank',
		allocation: 'Allocation',
		allocationsExpense: 'Allocated expenses present',
	},
	independence: {
		teamMember: 'חבר צוות',
		hoursCharged: 'Hours charged',
		independenceStatus: 'Overall independence status',
		confirmationDate: 'Confirmation date',
		memberFirm: 'Member firm',
		eyCanvasIndependenceStatus: 'EY Canvas independence status',
		employmentStatus: 'Employment status',
		country: 'Country',
		updatedBy: 'Updated by',
		updatedDate: 'Updated date',
		selectColumns: 'Select the columns',
		confirmationDateBefore: 'Confirmation date before',
		confirmationDateAfter: 'Confirmation date after',
		excelsummary: 'Summary',
		excelMercury: 'Data from Mercury',
		excelCanvas: 'Data from Canvas',
		name: 'Name',
		gui: 'GUI',
		rank: 'דַרגָה',
		emailAddress: 'Email address',
		clarification: 'Clarification',
		explanation: 'Explanation',
		updatedOn: 'Updated on',
		client: 'Client',
		mercuryEngagementCode: 'Mercury engagement code',
		canvasEngagement: 'Canvas engagement',
		email: 'Email',
		reason: 'Reason',
		engagementRole: 'Engagement role',
		location: 'Location',
		employeeStatus: 'Employee status',
		noResultsPlaceholder: 'לא נמצאו תוצאות',
		filter: {
			unassociatedFinancialCodes: 'Unassociated financial codes',
			unassociatedLabel: 'Unassociated',
			filterHeader: 'Independence filter',
			noFinancialCodeLabel: 'No financial code associated',
			noEngagementLabel: 'No EY Canvas engagement associated',
			expandText: 'Expand',
			collapseText: 'Collapse',
			noDataFound: 'No data found'
		}
	},
	header: {
		hours: 'שעות',
		actualHours: 'בפועל',
		forecastedHours: 'צפוי',
		variance: 'FTA variance',
		other: 'אחרים',
		ppedd: 'PPEDD',
		mgrSrMgr: 'SrMgr/Mgr',
		partnerHours: 'שעות שותפים',
		executiveDirector: 'ED',
		seniorManager: "סניור מנג'ר",
		manager: "מנג'ר",
		senior: 'סניור',
		staff: 'מתמחה',
		intern: 'מתמחה',
		billed: 'מחויב:',
		ter: 'TER:',
		forecastedTER: 'TER חזוי:',
		margin: 'מרווח',
		ansr: 'ANSR',
		cost: 'עלות',
		terSection: 'TER',
		billedSection: 'חוייב',
		forecastedTERSection: 'צפוי',
		forecastedTERSectionForHeader: 'Forecasted TER',
		completedTasks: 'משימות שהושלמו',
		completedAssignments: 'משימות סגורות',
		acceptedRequests: 'בקשות שהתקבלו',
		gdsUsage: 'שימוש ב- GDS',
		completedTasksTooltip: 'הושלם',
		totalTasksTooltip: 'סך הכול',
		completedAssignmentsTooltip: 'סגור',
		totalAssignmentsTooltip: 'סך הכול',
		acceptedRequestsTooltip: 'התקבל',
		sentRequestsTooltip: 'נשלח',
		gdsHoursTooltip: 'GDS',
		actualHoursTooltip: 'שעות בפועל',
		otherTooltip: 'Other',
		otherHeaderTooltip: 'Other',
		ppeddTooltip: 'PPEDD',
		mgrSrMgrTooltip: 'SrMgr/Mgr',
		partnerHoursTooltip: 'Partner/Principal',
		executiveDirectorTooltip: 'ED/D',
		seniorManagerTooltip: 'Sr. Manager',
		managerTooltip: 'Manager',
		seniorTooltip: 'Senior',
		staffTooltip: 'Staff',
		internTooltip: 'Intern',
		varianceTooltip: 'Forecast to actual variance',
		ansrTooltip: 'Adjusted net standard revenue (net fees excluding expenses)',
		marginTooltip: 'Margin = (ANSR - Cost) / ANSR',
		terSectionHover: 'Actual total engagement revenue (fees + expenses)',
		forecastedTERSectionHover: 'Forecasted total engagement revenue (fees + expenses)',
		billedSectionHover: 'Actual net invoice amount',
		gdsUsageHover: 'Global Delivery Service usage'
	},
	allocationsFilters: [{
		value: 1,
		label: 'Yes'
	}
	]
};

export const exportOptions = {
	buttonText: 'ייצא',
	downloadCSV: 'הורד CSV',
	downloadJPEG: 'הורד JPEG',
	downloadPDF: 'הורד PDF',
	downloadPNG: 'הורד PNG',
	downloadSVG: 'הורד SVG',
	downloadXLS: 'הורד XLS',
	exitFullscreen: 'יציאה ממסך מלא',
	viewFullscreen: 'הצג מסך מלא',
	printChart: 'הדפס תרשים'
};

export const adminLabels = {
	adminPortal: 'Administration',
	usersTab: 'Manage users',
	projectsTab: 'Manage projects',
	administrators: 'Manage administrators'
};

export const projectUserStatus = {
	active: 'Active',
	inactive: 'Inactive',
};

export const projectUserRoles = {
	defaultUser: 'Default user',
	projectAdministrator: 'מנהל פרויקט'
};

export const projectStatus = {
	active: 'Active',
	deleted: 'Deleted'
};

export const administratorRoles = {
	none: 'אף אחד',
	adminReader: 'Admin reader',
	adminWriter: 'Admin writer',
	superAdmin: 'Super admin'
}

export const addUser = {
	firstName: 'שם פרטי',
	lastName: 'שם משפחה',
	enterFirstNameText: 'Enter first name, last name or email address of user and press enter to search',
	selectRole: 'Role',
	userRole: 'User role',
	clear: 'Clear',
	email: 'Email',
	role: 'Role',
	cancel: 'בטל',
	addUser: 'Add User',
	close: 'Close',
	add: 'Add',
	addAdministrator: 'Add administrator',
	error1: 'The selected user is already a part of the project. Please review.',
	error2: 'Admin can only be priviledged user account'
};

export const adminManageProjects = {
	manageProjects: 'Manage projects',
	description: 'Search for a project by entering the project ID',
	projectId: 'Project ID',
	search: 'חפש',
	clearSearch: 'Clear',
	enterValidProject: 'Enter valid project ID',
	projectDetails: 'Project details',
	enterProjectName: 'Enter project name',
	projectName: 'Project name',
	projectStatus: 'Project status',
	financialCodes: 'Financial codes',
	noFinancialCodes: 'No financial engagement codes are mapped to this project',
	engagementCode: 'קוד התקשרות',
	client: 'Client',
	status: 'סטטוס',
	validatedBy: 'Validated by',
	canvasEngagements: 'EY Canvas engagements',
	canvasEngagement: 'EY Canvas engagement',
	noCanvasEngagements: 'No EY Canvas engagements are mapped to this project',
	member: 'Members',
	gui: 'GUI',
	firstName: 'שם פרטי',
	lastName: 'שם משפחה',
	emailAddress: 'Email address',
	userRole: 'User role',
	validated: 'Validated',
	unvalidated: 'לא מאומת',
	enterValidGui: 'Enter a valid GUI for project ID',
	requiredProjectName: 'Project name cannot be blank',
	successToastMessage: 'Changes saved successfully',
	resetToastMessage: 'Reset completed',
	errorToastMessage: 'At least one project member is required to be a Project administrator. Please review the changes.',
	independenceOnly: 'Independence only',
	yes: 'כן',
	no: 'לא'
};

export const manageAdministrators = {
	title: 'Manage administrators',
	firstName: 'שם פרטי',
	lastName: 'שם משפחה',
	email: 'Email',
	role: 'Role',
	description: 'Add new administrators or manage existing administrators',
	noInformationPlaceholder: 'No information available for the selected options.',
	updateAdminErrorToast: 'Update was unsuccessful. Please review and try again later.',
	updateAdminSuccessToast: 'Changes saved successfully',
};

export const adminManageUsers = {
	title: 'Manage users',
	description: 'Search for a user by entering their user GUI',
	inputLabel: 'User GUI',
	searchButtonLabel: 'Search',
	cancelButtonLabel: 'Clear',
	errorMessage: 'Enter a valid user GUI',
	userDetails: 'User details',
	projects: 'Projects',
	delegates: 'Delegates',
	settings: 'Settings',
	noResultsPlaceholder: 'No records found',
	delegatedTo: 'Delegated to:',
	delegatedFrom: 'Delegated from:',
	gui: 'GUI',
	firstName: 'שם פרטי',
	lastName: 'שם משפחה',
	emailAddress: 'Email address',
	projectName: 'Project name',
	projectId: 'Project ID'
};

export const adminCommon = {
	save: 'שמור',
	reset: 'Reset'
}
